<template>
  <div class="seasonsBannerContainer">
    <img src="/img/seasons-banner.png" alt="" class="seasonsBanner" />
    <div class="bannerContent">
      <div class="bannerLeft">
        <div class="prizeFundTitle">{{ $t('prizeFund2026') }}</div>
      </div>
      <div class="bannerRight">
        <div class="bannerButtonWrapper">
          <button class="bannerButton seasonsButton" @click="openModal('seasons')">{{ $t('seasons') }}</button>
          <div class="buttonBadge">50 000$</div>
        </div>
        <div class="bannerButtonWrapper">
          <button class="bannerButton jackpotButton" @click="openModal('jackpot')">{{ $t('jackpots') }}</button>
          <div class="buttonBadge">50 000$</div>
        </div>
      </div>
    </div>
    <SeasonPrizeInfoPopup v-model="isModalOpen" :type="modalType" />
  </div>
</template>

<script lang="ts" setup>
import SeasonPrizeInfoPopup from '~/widgets/seasons-prize/SeasonPrizeInfoPopup.vue';

type PrizeType = 'seasons' | 'jackpot';

const isModalOpen = ref(false);
const modalType = ref<PrizeType>('seasons');

const openModal = (type: PrizeType) => {
  modalType.value = type;
  isModalOpen.value = true;
};
</script>

<style lang="scss" scoped>
.seasonsBannerContainer {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.seasonsBanner {
  width: 100%;
  height: auto;
  object-fit: contain;
  display: block;
}

.bannerContent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 40px;
}

.bannerLeft {
  position: absolute;
  left: 20%;
  top: 28%;
  transform: translateX(-50%);
}

.prizeFundTitle {
  font-weight: 700;
  font-size: 16px;
  line-height: 100%;
  text-align: center;
  color: #ffffff;
  text-shadow:
    1px 1px 0 #000,
    -1px -1px 0 #000,
    1px -1px 0 #000,
    -1px 1px 0 #000,
    0px 1px 0 #000,
    0px -1px 0 #000,
    1px 0px 0 #000,
    -1px 0px 0 #000;
  white-space: nowrap;
}

.bannerRight {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: auto;
}

.bannerButtonWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  position: relative;
}

.bannerButton {
  padding: 10px 30px;
  border-radius: 48px;
  cursor: pointer;
  transition: opacity 0.2s;
  border: 2px solid #ffffff;
  font-weight: 700;
  font-size: 16px;
  line-height: 17.78px;
  text-align: center;

  &:hover {
    opacity: 0.9;
  }
}

.seasonsButton {
  background: linear-gradient(180deg, #17343e 0%, #010303 100%);
  color: #fff;
}

.jackpotButton {
  background: linear-gradient(270deg, #ffee33 -69.44%, #ffc800 -1.3%, #fff15d 45.82%, #ffc800 105.56%);
  color: #05141b;
}

.buttonBadge {
  padding: 2px 8px;
  border-radius: 24px;
  background: #fff;
  color: #05141b;
  position: absolute;
  top: 36px;
  box-shadow: 0px -4px 2px 0px #00000040 inset;
  font-weight: 700;
  font-size: 12px;
  line-height: 100%;
}
</style>
